/** File picker accept string for wizard and other image uploads (includes iOS HEIC). */
export const IMAGE_UPLOAD_ACCEPT =
  'image/jpeg,image/png,image/webp,image/gif,image/heic,image/heif,.heic,.heif';

function isHeicLike(file: File): boolean {
  const type = file.type.toLowerCase();
  if (type === 'image/heic' || type === 'image/heif') return true;
  const name = file.name.toLowerCase();
  return name.endsWith('.heic') || name.endsWith('.heif');
}

/**
 * Converts HEIC/HEIF to JPEG in the browser when possible (smaller upload, wider
 * MIME support). Server-side magic-byte validation + heic-convert still accept
 * native HEIC if conversion is skipped or fails.
 *
 * heic2any is dynamic-imported only for HEIC/HEIF files so Vitest/jsdom and other
 * suites that import upload helpers never load its canvas/worker bootstrap.
 */
export async function prepareUploadFile(file: File): Promise<File> {
  if (!isHeicLike(file)) {
    return file;
  }

  const { default: heic2any } = await import('heic2any');
  const converted = await heic2any({
    blob: file,
    toType: 'image/jpeg',
    quality: 0.92,
  });
  const jpegBlob = Array.isArray(converted) ? converted[0] : converted;
  const baseName = file.name.replace(/\.(heic|heif)$/i, '') || 'photo';
  return new File([jpegBlob], `${baseName}.jpg`, {
    type: 'image/jpeg',
    lastModified: file.lastModified,
  });
}
